import { watchEffect } from 'vue'
import type { Pinia } from 'pinia'
import { useSettingsStore } from '../stores/settings'
import { TOOL_COLORS, type ToolColor } from '../utils/toolSettings'
import { toolFormat } from '../utils/toolFormat'

// Applies Settings > Tools across the app. The six colors of calendar events, goals, and Docket lists. Each tool's
// styles read var(--tool-color-<name>, <theme default>), so a color the
// writer picks in Settings > Tools is set on the root and one left alone
// follows the theme.

export function startToolColors(pinia: Pinia) {
  const settings = useSettingsStore(pinia)
  // The clock and date style, for the label helpers (see utils/toolFormat).
  watchEffect(() => {
    toolFormat.clock = settings.toolPrefs.clock
    toolFormat.dateStyle = settings.toolPrefs.dateStyle
  })
  watchEffect(() => {
    const root = document.documentElement.style
    for (const color of TOOL_COLORS) {
      const value = settings.toolPrefs.colorValues[color]
      if (value) root.setProperty(`--tool-color-${color}`, value)
      else root.removeProperty(`--tool-color-${color}`)
    }
  })
}

/** The writer's name for a color, for pickers and their labels. */
export function toolColorName(color: ToolColor): string {
  return useSettingsStore().toolPrefs.colorNames[color]
}
